// src/store/user.store.ts
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { User } from "../types/index";

export type UserRole = "customer" | "chef" | "admin" | "deliveryAgent" | "cashier" | "kitchenOwner";

interface UserState {
  userProfile: User | null;
  walletBalance: number;
  currentRole: UserRole; // ✅ Track the current UI role separately

  setUserProfile: (user: User | null) => void;
  updateWalletBalance: (amount: number) => void;
  setWalletBalance: (balance: number) => void;
  clearUserProfile: () => void;

  // ✅ FIXED: Track current role for role switcher
  setCurrentRole: (role: UserRole) => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      userProfile: null,
      walletBalance: 0,
      currentRole: "customer", // ✅ DEFAULT: Customer is the default role

      setUserProfile: (user) =>
        set({
          userProfile: user,
          // ✅ When user logs in, set their default role from userProfile
          currentRole: user?.role || "customer",
        }),

      updateWalletBalance: (amount) =>
        set((state) => ({
          walletBalance: state.walletBalance + amount,
        })),

      setWalletBalance: (balance) => set({ walletBalance: balance }),

      clearUserProfile: () =>
        set({
          userProfile: null,
          walletBalance: 0,
          currentRole: "customer", // ✅ Reset to customer on logout
        }),

      // ✅ FIXED: Only update the current role (UI state), not userProfile
      setCurrentRole: (role: UserRole) => set({ currentRole: role }),
    }),
    {
      name: "ruchira-user-storage",
    }
  )
);
